import React from "react";
import Button from "./Button";
import { navigate } from "gatsby";

function CTA() {

  return (
    <div className="">
      <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-20 lg:px-8 lg:flex lg:items-center lg:justify-between">
        <h2 className="text-3xl leading-9 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
          Ready to dive in?
					<br />
          <span className="text-indigo-600">Get your templates today.</span>
        </h2>
        <div className="mt-8 flex lg:flex-shrink-0 lg:mt-0">
          <div className="inline-flex rounded-md shadow">
              <Button
                btnText="See templates"
                color="dark"
                onClick={() => navigate("/templates")}
              />
          </div>
          <div className="ml-3 inline-flex rounded-md shadow">
              <Button
                btnText="Contact us"
                color="light"
                onClick={() => navigate("/contact")}
              />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CTA;